import { toast } from "sonner";

/** Non-blocking «Генерация запущена» feedback shown right after a task
 * is created. Replaces an earlier full-screen Radix AlertDialog that
 * locked focus on mobile — once the dialog appeared the user couldn't
 * tap MobileBottomNav to switch tabs while waiting for the result.
 *
 * The toast carries the same message but stays out of the way, so the
 * page (and bottom-nav) remain fully interactive while polling runs in
 * the background. */
export function showGenerationStartedToast() {
    toast.success("Генерация запущена", {
        description: "Результат появится в «Истории». Можно продолжать пользоваться приложением.",
        duration: 5000,
    });
}
